import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Image from "@tiptap/extension-image";
import { Emoji, emojis } from "@tiptap/extension-emoji";
import { cn } from "../../lib/utils";
import { RICH_TEXT_EDITOR_PROSE_CLASSES } from "./constants";

export interface RichTextDisplayProps {
  content: string;
  className?: string;
}

/**
 * Renders rich text content using tiptap in read-only mode.
 *
 * Note: Pass `key={content}` to force remount when content changes dynamically,
 * as tiptap's useEditor doesn't reinitialize on prop changes.
 */
export const RichTextDisplay = ({ content, className }: RichTextDisplayProps) => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        bulletList: {
          keepMarks: true,
          keepAttributes: false,
        },
        orderedList: {
          keepMarks: true,
          keepAttributes: false,
        },
      }),
      Link.configure({
        openOnClick: true,
        HTMLAttributes: {
          class: "text-primary underline cursor-pointer",
        },
      }),
      Emoji.configure({
        emojis: emojis,
        enableEmoticons: true,
      }),
      Image.configure({
        inline: false,
        allowBase64: true,
      }),
    ],
    content,
    editable: false,
    editorProps: {
      attributes: {
        class: cn(...RICH_TEXT_EDITOR_PROSE_CLASSES, className),
      },
    },
  });

  if (!editor) {
    return null;
  }

  return <EditorContent editor={editor} className={className} />;
};
